
type SectionCardProps = {
    title: string;
    subtitle: string;
    statImage?: string;
};

const StatCard: React.FC<SectionCardProps> = ({ title, subtitle, statImage }) => {


    return (<div className='stat-card'>
        <div className='content-wrapper'>
            <div className="stat-title">{title}</div>
            <div className="stat-desc">{subtitle}</div>
        </div>
        <div className="img-wrapper">
            {statImage && <img src={statImage} alt="" />}
        </div>

    </div>)
}

export default StatCard;